import { CircleCheck } from 'lucide-react';
import { match } from 'ts-pattern';

import { Alert, AlertDescription, AlertTitle } from '@nesso/ui/primitives/alert';

interface Props {
    errorType: string | null;
}

export function SessionNoteError({ errorType }: Props) {
    return match(errorType)
        .with('NO_AUDIO', () => (
            <Alert variant="destructive">
                <CircleCheck className="size-4" />
                <AlertTitle>No Transcript available</AlertTitle>
                <AlertDescription>
                    <p>
                        We didn&apos;t capture any audio in this session. To prevent this in the
                        future, make sure:
                    </p>
                    <ol className="list-decimal list-inside mt-1 space-y-1">
                        <li>Your microphone is active and not muted.</li>
                        <li>Nesso has permission to access your microphone.</li>
                    </ol>
                </AlertDescription>
            </Alert>
        ))
        .otherwise(() => (
            <Alert variant="destructive">
                <CircleCheck className="size-4" />
                <AlertTitle>Unable to generate note</AlertTitle>
                <AlertDescription>
                    We cannot generate a therapy note based on the transcript provided.
                </AlertDescription>
            </Alert>
        ));
}
